export default "__VITE_ASSET__BLSZWigm__"